// https://testnet.snowscan.xyz/address/0x5488A48E5C22175548E8d68622211F5928cBbf23
export const CROSS_CHAIN_CONTROLLER = '0x5488A48E5C22175548E8d68622211F5928cBbf23';

// https://testnet.snowscan.xyz/address/0x79Edd77c76F95b6b69907CaD1d8241F9DB0e3FD0
export const VOTING_MACHINE = '0x79Edd77c76F95b6b69907CaD1d8241F9DB0e3FD0';

// IPayloadsControllerCore https://testnet.snowscan.xyz/address/0xf1842f9D6C3D9ec1153d7afCBb9cDBC537Ea5d15
export const PAYLOADS_CONTROLLER = '0xf1842f9D6C3D9ec1153d7afCBb9cDBC537Ea5d15';

// https://testnet.snowscan.xyz/address/0xACd2b1bA0B85FaF0f45D4974Ba8ee538E157fBc6
export const EXECUTOR_LVL_1 = '0xACd2b1bA0B85FaF0f45D4974Ba8ee538E157fBc6';

// IVotingStrategy https://testnet.snowscan.xyz/address/0x8c55a1bf3DC7076522C5cd025f497A498eF90143
export const VOTING_STRATEGY = '0x8c55a1bf3DC7076522C5cd025f497A498eF90143';

// IDataWarehouse https://testnet.snowscan.xyz/address/0xDB23939d4C483E748c2487916fB20d7fF7e39588
export const DATA_WAREHOUSE = '0xDB23939d4C483E748c2487916fB20d7fF7e39588';

export const CHAIN_ID = 43113;
